import { render, staticRenderFns } from "./baseHead.vue?vue&type=template&id=4536b627&scoped=true"
import script from "./baseHead.vue?vue&type=script&lang=js"
export * from "./baseHead.vue?vue&type=script&lang=js"
import style0 from "./baseHead.vue?vue&type=style&index=0&id=4536b627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4536b627",
  null
  
)

export default component.exports